import { jsx as _jsx } from "react/jsx-runtime";
import { useShortIdContext } from "@air/provider-short-id";
import { useRouter } from "next/router";
import { memo, useCallback } from "react";
import { usePublicWorkspace } from "~/components/PublicWorkspaceProvider";
import { SocketContextProvider } from "~/providers/SocketContext/SocketContext";
export const PublicClipSocketContextProvider = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    const { isReady } = useRouter();
    const { shortId } = useShortIdContext();
    const { workspaceId } = usePublicWorkspace();
    const getAuthToken = useCallback(()=>Promise.resolve(shortId), [
        shortId
    ]);
    return /*#__PURE__*/ _jsx(SocketContextProvider, {
        connect: isReady,
        getAuthToken: getAuthToken,
        currentWorkspaceId: workspaceId,
        children: children
    });
});
PublicClipSocketContextProvider.displayName = "_PublicClipSocketContextProvider";
